import LegacyCard from './LegacyCard';

export default LegacyCard;
